import request from '@/axios'

// B-01-确认小区信息（新）
export function confirmVillage(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_evaluating/confirmVillage',
    method: 'post',
    data
  })
}

// B-02-确认户型结构（新）
export function confirmStructure(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_evaluating/confirmStructure',
    method: 'post',
    data
  })
}

// B-03-添加测评（新）
export function addEvaluating(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_evaluating/addEvaluating',
    method: 'post',
    data
  })
}

// B-04-户型选项列表（新）
export function optionList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_evaluating/optionList',
    method: 'post',
    data
  })
}

// B-05-获取空间用途列表（新）
export function getDemand(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_evaluating/getDemand',
    method: 'post',
    data
  })
}

// B-06-确认空间
export function confirmSpace(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_evaluating/confirmSpace',
    method: 'post',
    data
  })
}

// 设计师-03-风格方案库
export function styleProgramList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/designer/style/programList',
    method: 'post',
    data
  })
}

// 设计师-04-风格-空间标签
export function getLabels(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/designer/style/getLabels',
    method: 'post',
    data
  })
}

// 设计师-04-风格-空间标签
export function spaceProgramList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/designer/space_program/programList',
    method: 'post',
    data
  })
}

// 设计师-02-方案详情
export function spaceProgramDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/designer/space_program/programDetail',
    method: 'post',
    data
  })
}

// 设计师-01-风格详情
export function styleProgramDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/designer/style/styleDetail',
    method: 'post',
    data
  })
}

// 用户-01-(取消)标记喜欢风格
export function markLoveStyle(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/designer/style/markLove',
    method: 'post',
    data
  })
}

// 用户-02-(取消)标记喜欢空间方案
export function markLoveSpace(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/designer/space_program/markLove',
    method: 'post',
    data
  })
}

// 设计师-06-客户已选方案信息
export function customerProgram(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/designer/space_program/customerProgram',
    method: 'post',
    data
  })
}

// A-工程交底-0703-工程预排(排期提交前预存)
export function preSchedule(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/v2/disclose/preSchedule',
    method: 'post',
    data
  })
}

